import { render, staticRenderFns } from "./ReceiveAndReturns.vue?vue&type=template&id=f34f4ffc&scoped=true&"
import script from "./ReceiveAndReturns.vue?vue&type=script&lang=ts&"
export * from "./ReceiveAndReturns.vue?vue&type=script&lang=ts&"
import style0 from "./ReceiveAndReturns.vue?vue&type=style&index=0&id=f34f4ffc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34f4ffc",
  null
  
)

export default component.exports